/** * スケジュール編集コンポーネント */
<template>
  <div class="schedule-edit">
    <loading-mask isFullScreen v-bind:isLoading="isLoading" />
    <ifield-b-modal
      id="schedule-edit-dialog"
      ref="schedule-edit-dialog-modal"
      v-bind:title="domainName"
      centered
      scrollable
      no-body-border
      size="lg"
      ok-variant="success"
      ignore-enforce-focus-selector=".popover"
      v-bind:dialog-class="{ hidden: isLoading }"
      v-bind:ok-title="okTitle"
      v-bind:cancel-title="$t('theScheduleEditor.action.cancel')"
      v-on:ok.prevent="$_saveSchedule"
    >
      <schedule-editor
        ref="schedule-editor"
        v-bind:domainName="domainName"
        v-bind:sendMessage="sendMessage"
        v-on:schedule-editend="$_onEditEnd"
        v-on:schedule-editfailed="$_onEditFailed"
      />
    </ifield-b-modal>
  </div>
</template>

<script>
import ScheduleEditor from '@/components/schedule/AppScheduleEditor.vue'

export default {
  name: 'TheScheduleEditor',
  components: {
    'schedule-editor': ScheduleEditor,
  },
  props: {
    /**
     * ドメイン名称
     */
    domainName: {
      type: String,
      default: function () {
        return this.$t('theScheduleEditor.schedule')
      },
    },
    /**
     * 対象者にメッセージを送信する場合はtrue
     */
    sendMessage: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      // 新規作成か？
      isCreate: true,
      // ロード中か？
      isLoading: false,
    }
  },
  computed: {
    /**
     * OKボタンの文言
     * @type {String}
     */
    okTitle: function () {
      return this.isCreate
        ? this.$t('theScheduleEditor.action.register')
        : this.$t('theScheduleEditor.action.update')
    },
  },
  mounted: function () {
    this.$log.info('TheScheduleEditor mounted.')
  },
  methods: {
    /**
     * ダイアログを表示する
     *
     * @param {Object} [data=null] 更新対象データ
     * @param {String} [defaultValues=null] 初期値オブジェクト
     * @public
     */
    showModal: async function (data = null, defaultValues = null) {
      this.$_showLoading()
      this.isCreate = data == null
      this.$refs['schedule-edit-dialog-modal'].show()
      this.$nextTick(async () => {
        await this.$refs['schedule-editor'].show(data, defaultValues)
        this.$_hideLoading()
      })
    },

    /**
     * ダイアログを非表示にする
     * @public
     */
    hideModal: function () {
      this.$refs['schedule-edit-dialog-modal'].hide()
    },

    /**
     * スケジュールを保存する
     */
    $_saveSchedule: async function () {
      this.$refs['schedule-editor'].save()
    },

    /**
     * スケジュール保存完了時処理
     *
     * @param {Boolean} isCreate 新規登録かどうか
     */
    $_onEditEnd: function (isCreate) {
      /**
       * スケジュール保存完了後のイベント
       * @param {Boolean} isCreate 新規登録かどうか
       */
      this.$emit('schedule-editend', isCreate)
      this.hideModal()
    },

    /**
     * スケジュール保存失敗時処理
     * @param {Number} id 失敗したスケジュールID
     */
    $_onEditFailed: function (id) {
      /**
       * スケジュール保存失敗イベント
       * @param {Number} id 対象スケジュールID
       */
      this.$emit('schedule-editfailed', id)
      this.hideModal()
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .hidden {
  display: none;
}
</style>
